import { render, staticRenderFns } from "./completing.vue?vue&type=template&id=3b071c6a"
import script from "./completing.vue?vue&type=script&lang=js"
export * from "./completing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports